import styled from "styled-components";

export const RootContainer = styled.div`
	.infinite-scroll-component__outerdiv {
		height: calc(100vh - 70px);
	}

	.infinite-scroll-component {
		height: 100% !important;
		overflow-x: hidden !important;
	}
`;

export const HistoryBoxesContainer = styled.div`
	margin: 16px;
	border-radius: 16px;
	border: 1px solid #DEEDFF;
	background: #FFF;
	min-height: calc(100vh - 70px - 32px);
`

export const HistoryBox = styled.div`
	display: flex;
	flex-direction: column;
	padding: 16px 16px;
	gap: 8px;
	border-bottom: 1px solid #DEEDFF;
`;

export const DateAndAmountContainer = styled.div`
	display: flex;
	flex-direction: row;
`;
export const Date = styled.p`
	flex-grow: 1;
	text-align: left;
	color: #000000;
	font-size: 15px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
`;
export const Amount = styled.p`
	color: #004F9C;
	text-align: right;
	font-size: 15px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
`;

export const ExpireBox = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: start;
	align-items: center;
	gap: 4px;
`;

export const ExpireText = styled.p`
	color: #BA0101;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 15.92px; /* 107.692% */
`;

export const ExpiredTime = styled.p`
	color: #969696;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 14px; /* 107.692% */
`;

export const SpinWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: ${(props) =>
		props.size === "large" ? "calc(100vh - 70px)" : "auto"};
`;

export const EmptyText = styled.div`
	color: #000000;
`;

export const EmptyWrapper = styled.div`
	height: 660px;
	gap: 10px;
	flex-direction: column;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 16px;
	border-radius: 16px;
	border: 1px solid #DEEDFF;
	background: #FFF;
`;


